/* ═══════════════════════════════════════════════════════════════
   Wetterteil — Witterung und Klimareihe gehören nicht zum Kellerbuch

   `weatherCache` und `klimaCache` sind abgerufene Daten, keine
   Eingaben. Bei einem großen Keller mit Witterung machten sie rund
   die Hälfte des Kellerbuchs aus — und gingen bei jedem Speichern
   mit zum Server, in jeden Vergleich und in jede lokale Kopie. Über
   4 MB lehnte der Server das Speichern ab.

   Jetzt bleiben sie im Speicher der App (`db` trägt sie weiter, damit
   alle Ansichten unverändert lesen), werden aber:
     - nicht hochgeladen (`ohneWetter` in apiSpeichern),
     - beim Vergleich „hat sich etwas geändert?“ übergangen
       (`serialisiere`),
     - lokal getrennt abgelegt (dienste/lokalkopie.js).
   Ein zweites Gerät holt fehlende Werte vom Server — der hält sie
   ohnehin im eigenen Zwischenspeicher (wetter.js), Open-Meteo wird
   dafür nicht erneut gefragt.
   ═══════════════════════════════════════════════════════════════ */

const WETTER_FELDER = ["weatherCache", "klimaCache"];

/** Das Kellerbuch ohne Wetterteil — flache Kopie, nur wenn nötig. */
function ohneWetter(db) {
  if (!db || typeof db !== "object") return db;
  if (!WETTER_FELDER.some((k) => k in db)) return db;
  const raus = { ...db };
  for (const k of WETTER_FELDER) delete raus[k];
  return raus;
}

/** Nur der Wetterteil. */
function wetterTeil(db) {
  return {
    weatherCache: (db && db.weatherCache) || {},
    klimaCache: (db && db.klimaCache) || {},
  };
}

const hatWetter = (teil) => !!teil && WETTER_FELDER.some((k) => teil[k] && Object.keys(teil[k]).length > 0);

/** Wetterteile in `db` einsetzen. Spätere Quellen gewinnen je
    Schlüssel; der eigene Teil von `db` (etwa ein Altstand vom Server,
    der ihn noch mitführt) zählt als erste Quelle. */
function mitWetter(db, ...quellen) {
  if (!db) return db;
  const raus = { ...db };
  for (const k of WETTER_FELDER) {
    /* Nicht leere Teile, jeder höchstens einmal. Bleibt genau einer,
       wird er unverändert übernommen — gleiche Referenz heißt für die
       App „unverändert“, es wird dann nichts neu abgelegt. */
    const teile = [];
    for (const q of [db, ...quellen]) {
      const w = q && q[k];
      if (w && Object.keys(w).length > 0 && !teile.includes(w)) teile.push(w);
    }
    raus[k] = teile.length === 0 ? (db[k] || {}) : teile.length === 1 ? teile[0] : Object.assign({}, ...teile);
  }
  return raus;
}

/** Vergleichsform: Was zum Server geht, als Zeichenkette. */
const serialisiere = (db) => (db ? JSON.stringify(ohneWetter(db)) : null);

export { WETTER_FELDER, hatWetter, mitWetter, ohneWetter, serialisiere, wetterTeil };
